require('../../node_modules/lodash.merge/index.js');
require('./utils.js');
require('./debug.js');
require('../../node_modules/hammerjs/hammer.min.js');
require('../../libs/reflex-library/src/lib/shape.js');
require('./pixi-spine.js');
require('../../libs/reflex-library/src/lib/gsap.min.js');
require('./LoaderController.js');
require('./game.js');
require('./soundManager.js');
require('./CascadingReels/spinFunctions.js');
require('./CascadingReels/cascadeInfiniReels.js');
require('./gamePaytable.js');
require('./CascadingReels/gameReelManager.js');
require('./CascadingReels/gameSlotMachine.js');
require('./gameController.js');
require('./ParticleController.js');
require('./Feature/FreeSpins/freespinsController.js');
require('./Feature/FreeSpins/freeSpinsIntro.js');
require('./Feature/FreeSpins/freeSpinsOutro.js');
require('./Feature/FreeSpins/freeSpinsOutroNoWin.js');
require('./Feature/FreeSpins/freeSpinsRetrigger.js');
require('./Feature/FreeSpins/minMultiplierPopup.js');
require('./Feature/GambleSpin/GambleToggleView.js');
require('./GameHelpers.js');
require('../../libs/reflex-library/src/lib/screenDimObject.js');
require('../../libs/reflex-library/src/lib/screenshotAnimator.js');
require('./Feature/GambleSpin/GambleSpinController.js');
require('./AudioController.js');
// require('./ShowReelView.js');
require('./UI/GameSlamStopButtonComponent.js');
require('./BigWinController.js');
require('./winTextPopup.js');
require('./freeSpinsTotalWinPanel.js');
require('../../libs/reflex-library/src/lib/colourBox.js');
// require('./Feature/GambleSpin/ArrowComponent.js');
require('./ScrollContainer.js');
require('./bgTrail.js');
require('./outcomesPanel.js');
require('./outcomesPanelButton.js');
require('./UI/LuckyBetToggleController.js');
require('./UI/GambleModeButton.js');
require('./Feature/FreeSpins/freeSpinsMeter.js');
// require('../../libs/reflex-library/src/lib/spine.js');
require('./gameSpineManager.js');
require('./UI/StakeMinusButtonComponent.js');
require('./UI/StakePlusButtonComponent.js');
require('./payAnywhereWinAnimator.js');
require('./WinTextController.js');
require('./BuyBonus/BuyBonusButtonComponent.js');
require('./BuyBonus/BuyBonusPopupView.js');
require('./UI/SettingsMenuController.js');
require('./UI/SettingsMenuButtonComponent.js');
require('./UI/GameSkipWinsButtonComponent.js');

//Setting Menu Buttons
require('./SystemSettings/SystemSettingVolumeButtonComponent.js');
require('./SystemSettings/SystemSettingsButtonComponent.js');
require('./SystemSettings/SystemSettingsCloseComponent.js');
require('./SystemSettings/SystemSettingsIntroScreenButtonComponent.js');
require('./SystemSettings/SystemSettingsSoundsComponents.js');
require('./SystemSettings/SystemSettingsBoxView.js');
require('./SystemSettings/SettingSound.js');

//Stake/Bet Menu
require('./StakeSettings/stakeSelectionPopup_ext.js');

//Autoplay
require('./AutoplaySettings/autoplayManager-ext.js');

//Menubar
require('./SideMenu/SideMenuCloseComponent.js');
require('./SideMenu/SideMenuHelpComponent.js');
require('./GameRecoveryController.js');
